import { render, staticRenderFns } from "./Enrolldetail.vue?vue&type=template&id=9b9cb5f0"
import script from "./Enrolldetail.vue?vue&type=script&lang=js"
export * from "./Enrolldetail.vue?vue&type=script&lang=js"
import style0 from "./Enrolldetail.vue?vue&type=style&index=0&id=9b9cb5f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports